/*
 * @Author: 王月琪 qdd88899@163.com
 * @Date: 2024-10-18 15:15:30
 * @LastEditors: wangyueqi
 * @LastEditTime: 2024-10-29 09:58:01
 * @FilePath: \yanglaodaping\yiliaodaping\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './api/http'
import '@/assets/reset.css'
import 'element-ui/lib/theme-chalk/index.css';
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
import '@/until/ele'
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts
Vue.use(dataV)

Vue.config.productionTip = false
Vue.prototype.$http=http
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
